/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";

export class TombstoneSoundConfig implements ISoundConfig {

    public static instance:TombstoneSoundConfig = new TombstoneSoundConfig();

    MAIN_GAME_AMBIANCE:string = "background-music-main";
    JUSTICE_AMBIANCE:string = "background-music-fs";
    GUNSLINGER_AMBIANCE:string = "background-music-fs";
    BOUNTY_AMBIANCE:string = "background-music-fs";

    AS_WIN:string = "asWin";
    AS_WIN_BIG:string = "asWinBig";

    REELS_SPINNING_START_ON_SPIN_START:string = "reelsSpinning";
    REELS_SPINNING_STOP_DELAY:number = 50;
    REELS_DEFAULT_BOUNCE:string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];

    PISTOLS:string[] = ["pistol1", "pistol2", "pistol3", "pistol4", "pistol5"];

    SHOOT_WINDOW:string = "shootWindow";
    SHOOT_WINDOW_EMPTY:string = "shootWindowEmpty";

    WIN_TINY:string = "winTiny";
    WIN_SMALL:string = "winSmall";
    WIN_MEDIUM:string = "winMedium";
    WIN_LARGE:string = "winLarge";

    COUNT_UP:string = "countup";
    COUNT_UP_ENDS:string = "countupEnds";
    COUNT_UP_BACK:string = "winAmountBack";
    MULTIPLIER_WIN:string = "multiplierWin";

    NUDGE:string = "nudge1";
    NUDGE_END:string = "nudge2";
    NUDGE_NO_WIN:string = "nudgeNoWin";

    MULTIPLIER1:string = "multiplier1";
    MULTIPLIER2:string = "multiplier2";
    MULTIPLIER3:string = "multiplier3";

    DOOR_CLOSE:string = "doorClosing";
    DOOR_OPEN:string = "doorOpens";

    SCATTER_LANDING_1:string = "scatter1";
    SCATTER_LANDING_2:string = "scatter2";
    SCATTER_LANDING_WIN:string = "scatterWin";
    SCATTER_LANDING_FREESPIN:string = "scatter1";
    SCATTER_WIN:string = "scatterAllAnim";
    FSPlusOne:string = "fsPlusOne";

    BONUS_LANDING:string = "starScatter1";
    BONUS_LANDING_JUSTICE_WIN:string = "starScatterWin";
    BONUS_LANDING_BOUNTY_WIN:string = "starScatterWinBounty";
    BONUS_WIN:string = "starScatterText";

    ANTICIPATION_REEL3:string = "anticipation1";
    ANTICIPATION_REEL4:string = "anticipation2";
    ANTICIPATION_FAIL:string = "anticipationFail";

    JUSTICE_INTRO:string = "fsIntroJustice";
    GUNSLINGER_INTRO:string = "fsIntroGunslinger";
    BOUNTY_INTRO:string = "fsIntroBounty";

    JUSTICE_OUTRO:string = "fsEnds";
    GUNSLINGER_OUTRO:string = "fsEnds";
    BOUNTY_OUTRO:string = "fsEnds";
    JUSTICE_NOWIN_OUTRO:string = "fsEndsNoWin";
    GUNSLINGER_NOWIN_OUTRO:string = "fsEndsNoWin";
    BOUNTY_NOWIN_OUTRO:string = "fsEndsNoWin";

    BIG_WIN_INITIAL:string = "bigwinStart";
    BIG_WIN:string = "bigwin";
    BIG_WIN_ENDS_0:string = "bigwinEnds1";
    BIG_WIN_ENDS_1:string = "bigwinEnds2";
    BIG_WIN_ENDS_2:string = "bigwinEnds3";

    CAP_WIN_INTRO:string = "capwinIntro";
    CAP_WIN_LOOP:string = "capwinLoop";
    CAP_WIN_ENDS:string = "capwinEnds";

    WIND:string = "wind";

    constructor() {
        if(TombstoneSoundConfig.instance) {
            throw new Error("TombstoneSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    static getNormalWinSoundName(type:WinRatioType):string | null {
        switch(type) {
            case WinRatioType.TINY:
                return TombstoneSoundConfig.instance.WIN_TINY;
            case WinRatioType.SMALL:
                return TombstoneSoundConfig.instance.WIN_SMALL;
            case WinRatioType.MEDIUM:
                return TombstoneSoundConfig.instance.WIN_MEDIUM;
            case WinRatioType.LARGE:
                return TombstoneSoundConfig.instance.WIN_LARGE;
            default:
                return null;
        }
    }

    static getPistolSoundName():string {
        return ArrayHelper.getRandomElementFromArray(TombstoneSoundConfig.instance.PISTOLS);
    }
}